/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (diffusion effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		prompt: {
			type: 'string',
			initial: '',
			morph: true,
			tip: 'Text prompt',
			kind: 'prompt',
			placeholder: 'Enter a text prompt',
			tooltip: {
				heading: 'Text Prompt',
				body: 'Describe what you want to see (objects, styles). It works better as a list of tags rather than complicated sentences',
			},
		},
		strength: {
			type: 'integer',
			minimum: 0,
			maximum: 999,
			step: 1,
			initial: 321,
			label: 'Imagination',
			tip: 'Diffusion strength (entry noise level)',
			kind: 'range',
			display_multiplier: 0.1,
			natural_step: 10,
			icon: 'tb/galaxy',
			tooltip: {
				heading: 'Imagination Strength',
				body: 'Controls the intensity of the AI imagination applied to your video.',
			},
		},
		detail: {
			type: 'integer',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 20,
			label: 'Detail',
			tip: 'Detail between denoise steps',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Detail',
				body: 'How much fine detail carries from one denoise step to the next. Low values re-noise between steps; high values keep more of the detail the first step found.',
			},
		},
		seed: {
			type: 'integer',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 1,
			morph: true,
			tip: 'Seed noise',
			kind: 'number',
			icon: 'gi/spades',
		},
	},
	label: 'Imagination',
	primary: ['strength', 'prompt'],
}
